import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { useToast } from '../context/ToastContext';
import logger from '../utils/logger';
import { LogOut } from 'lucide-react';

const ImpersonationBanner = () => {
  const { user, isImpersonating, exitImpersonation } = useAuth();
  const { t } = useLanguage();
  const { showError } = useToast();
  const [exiting, setExiting] = useState(false);

  if (!isImpersonating) return null;

  const handleExit = async () => {
    setExiting(true);
    try {
      await exitImpersonation();
      // Full reload + history replace to reset all in-memory caches tied to
      // the impersonated session (fiscal years, dashboards, etc.).
      window.location.replace('/');
    } catch (error) {
      logger.error('Failed to exit impersonation:', error);
      showError(t('impersonation.error'));
      setExiting(false);
    }
  };

  const displayName = user?.name || user?.email || '';

  return (
    <div
      data-testid="impersonation-banner"
      className="w-full bg-amber-200 border-b-2 border-amber-500 text-amber-900 px-6 py-3 flex items-center justify-between gap-4"
    >
      <span className="text-sm font-medium truncate">
        {t('impersonation.banner').replace('{name}', displayName)}
      </span>
      <button
        type="button"
        onClick={handleExit}
        disabled={exiting}
        data-testid="exit-impersonation-btn"
        className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-amber-500 text-white text-sm font-medium hover:bg-amber-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0"
      >
        <LogOut className="w-4 h-4" />
        {t('impersonation.exitButton')}
      </button>
    </div>
  );
};

export default ImpersonationBanner;
